<template>
  <a-layout>
    <a-layout-content :style="{ padding: '20px', background: '#fff', minHeight: 'calc(100vh - 64px)' }">
      <a-row :gutter="16">
        <!-- 左侧表单区域（缩小为8列） -->
        <a-col :span="8">
          <a-card
              title="称重信息录入"
              :bordered="false"
              :headStyle="{ borderBottom: '1px solid #e8e8e8' }"
              :bodyStyle="{ padding: '24px' }"
          >
            <a-form :form="form" @submit="handleSubmit">
              <a-form-item label="条形码号" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                <a-input
                    v-decorator="[
                    'barCodeNo',
                    {
                      rules: [{ required: true, message: '请输入条形码号' }],
                    }
                  ]"
                    placeholder="请输入条形码号"
                />
              </a-form-item>

              <a-form-item label="长度(cm)" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                <a-input-number
                    v-decorator="['whtLength']"
                    :min="0"
                    :step="0.1"
                    style="width: 100%"
                    placeholder="请输入长度"
                />
              </a-form-item>

              <a-form-item label="宽度(cm)" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                <a-input-number
                    v-decorator="['whtWidth']"
                    :min="0"
                    :step="0.1"
                    style="width: 100%"
                    placeholder="请输入宽度"
                />
              </a-form-item>

              <a-form-item label="高度(cm)" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                <a-input-number
                    v-decorator="['whtHeight']"
                    :min="0"
                    :step="0.1"
                    style="width: 100%"
                    placeholder="请输入高度"
                />
              </a-form-item>

              <a-form-item label="重量(kg)" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                <a-input-number
                    v-decorator="[
                    'weight',
                    {
                      rules: [{ required: true, message: '请输入重量' }],
                    }
                  ]"
                    :min="0"
                    :step="0.1"
                    style="width: 100%"
                    placeholder="请输入重量"
                />
              </a-form-item>

              <a-form-item :wrapper-col="{ span: 16, offset: 8 }">
                <a-button type="primary" html-type="submit" style="margin-right: 10px;">
                  确定
                </a-button>
                <a-button @click="handleReset">
                  清空数据
                </a-button>
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>

        <!-- 右侧记录列表区域（扩大为16列） -->
        <a-col :span="16">
          <a-card
              title="称重记录"
              :bordered="false"
              :headStyle="{ borderBottom: '1px solid #e8e8e8' }"
              :bodyStyle="{ padding: '24px' }"
          >
            <div style="margin-bottom: 16px; display: flex;gap: 20px">
              <a-input-search
                  v-model="searchText"
                  placeholder="按条形码号搜索"
                  style="width: 300px"
                  allowClear
                  @search="onSearch"
              />
              <a-button type="primary" @click="onSearch">查询</a-button>
            </div>

            <a-table
                :columns="columns"
                :dataSource="records"
                :pagination="pagination"
                rowKey="barCodeNo"
                bordered
                @change="handleTableChange"
            >
              <template slot="volume" slot-scope="text, record">
                {{ record.whtLength }} * {{ record.whtWidth }} * {{ record.whtHeight }}
              </template>
            </a-table>
          </a-card>
        </a-col>
      </a-row>
    </a-layout-content>
  </a-layout>
</template>

<script>
import {orderWeigh, pageWeighingLog} from 'api/app';

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      records: [], // 存储所有称重记录
      searchText: '', // 搜索文本
      pagination: {
        pageSize: 10,
        current: 1,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '50'],
        showTotal: total => `共 ${total} 条记录`,
      },
      columns: [
        {
          title: '条形码号',
          dataIndex: 'barCodeNo',
          key: 'barCodeNo',
          width: '20%',
          align: 'center',
        },
        {
          title: '重量(kg)',
          dataIndex: 'weight',
          key: 'weight',
          width: '15%',
          align: 'center',
        },
        {
          title: '尺寸',
          key: 'volume',
          scopedSlots: {customRender: 'volume'},
          width: '20%',
          align: 'center',
        },
        {
          title: '计费重量(kg)',
          dataIndex: 'billingWeight',
          key: 'billingWeight',
          width: '15%',
          align: 'center',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
          align: 'center',
          width: '30%',
        },
      ],
    };
  },
  // computed: {
  //   filteredRecords() {
  //     // 现在直接返回当前页数据(由API处理)
  //     return this.records;
  //   },
  // },
  created() {
    this.fetchWeighRecords();
  },
  methods: {
    async handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            const params = {
              barCodeNo: values.barCodeNo,
              whtLength: values.whtLength,
              whtWidth: values.whtWidth,
              whtHeight: values.whtHeight,
              weight: values.weight
            }
            // 调用称重接口
            const response = await orderWeigh(params);

            if (response.code == 200) {
              this.$message.success('称重记录已保存');
              // 重置表单
              this.form.resetFields();
              // 刷新列表数据
              await this.fetchWeighRecords();
            } else {
              this.$message.error(response.msg || '称重保存失败');
            }
          } catch (error) {
            console.error('称重保存错误:', error);
            this.$message.error('称重保存失败，请稍后重试');
          }
        }
      });
    },
    async fetchWeighRecords() {
      try {
        const params = {
          barCodeNo: this.searchText,
          current: this.pagination.current,  // 当前页码
          size: this.pagination.pageSize      // 每页条数
        }
        const response = await pageWeighingLog(params);
        this.records = response.data.records || [];
        this.pagination.total = response.data.total || 0;
      } catch (error) {
        console.error('获取称重记录错误:', error);
        this.$message.error('获取称重记录失败，请稍后重试');
      }
    },
    // 处理分页变化
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.fetchWeighRecords(); // 重新获取数据
    },
    handleReset() {
      this.form.resetFields();
    },

    onSearch() {
      // 重置为第一页
      this.pagination.current = 1;
      this.fetchWeighRecords();
    },
  },
};
</script>

<style scoped>
/* 全局样式 */
.ant-input-number {
  width: 100%;
}

/* 左侧卡片样式 */
.ant-col-8 .ant-card {
  border-right: 1px solid #e8e8e8;
  height: 100%;
  box-shadow: 1px 0 4px rgba(0, 0, 0, 0.1);
}

/* 右侧卡片样式 */
.ant-col-16 .ant-card {
  margin-left: -1px; /* 使分割线对齐 */
  height: 100%;
}

/* 表格样式 */
.ant-table {
  border: 1px solid #e8e8e8;
}

/* 表单标签样式 */
.ant-form-item-label {
  font-weight: 500;
}

/* 按钮区域样式 */
.ant-form-item {
  margin-bottom: 16px;
}
</style>
